module.exports = __webpack_public_path__ + "static/media/bg2.17493276.png";